import {
  FormSlug,
  ImplementationGuideForm,
  ResponseFormat,
} from "@/components/ImplementationGuide/types";
import { FieldName } from "@/components/ImplementationGuide/types/FieldName.enum";

const instructionalBestPractices: ImplementationGuideForm = {
  title: "Instructional best practices",
  subtitle:
    "Offer practical guidance to teachers on how to best incorporate Newsela into their instruction.",
  slug: FormSlug.InstructionalBestPractices,
  form_image: "/images/implementation-guide/Best_Practices.svg",
  form_index: 4,
  form_description: {
    content:
      "We will provide recommendations on how to best incorporate Newsela into your district's instructional practices.",
    recommendation: "",
  },
  questions: [
    {
      question_index: 1,
      question_text:
        "We recommend assigning your students two or more Newsela texts and one quiz per week. This dosage has been associated with gains of approximately 5 percentiles on standardized ELA and Social Studies assessments for elementary and secondary students across the United States.",
      sub_prompt:
        "How confident are you that your district can reach this level of usage?",
      response_format: ResponseFormat.level_of_confidence,
      is_response_read_only: false,
      field_name: FieldName.Usage_Level_Confidence,
      response_fields: {
        textarea_title: "Notes",
        textarea_placeholder: "",
        textarea_field_name: FieldName.Usage_Level_Notes,
      },
    },
    {
      question_index: 2,
      question_text:
        "Every time teachers use Newsela we recommend that teachers commit to providing time for reading and separate time for processing after reading.",
      sub_prompt:
        "How confident are you in providing this guidance for your district?",
      response_format: ResponseFormat.level_of_confidence,
      is_response_read_only: false,
      field_name: FieldName.Time_Commitment_Confidence,
      response_fields: {
        textarea_title: "Notes",
        textarea_placeholder: "",
        textarea_field_name: FieldName.Time_Commitment_Notes,
      },
    },
    {
      question_index: 3,
      question_text:
        "What kind of practices will you put in place to achieve this level of usage for Newsela?",
      sub_prompt: null,
      response_format: ResponseFormat.textarea,
      response_fields: {
        textarea_title: "Response",
      },
      is_response_read_only: false,
      field_name: FieldName.Usage_Level_Practices,
    },
  ],
  resources: [
    {
      resource_name: "Implementation Recommendations",
      resource_link:
        "https://go.newsela.com/rs/628-ZPE-510/images/Efficacy-Recommendations.pdf?version=0",
      resource_link_text: "Open PDF",
      todo_item: "Provided implementation framework and training to teachers",
    },
    {
      resource_name: "Start a Literacy Routine",
      resource_link:
        "https://go.newsela.com/rs/628-ZPE-510/images/4-Step-Literacy-Routine-with-Newsela.pdf?_ga=2.129698892.1507216233.1721923970-1354303166.1721153701",
      resource_link_text: "Open PDF",
      todo_item: "",
    },
    {
      resource_name: "Newsela Efficacy Findings",
      resource_link:
        "https://go.newsela.com/rs/628-ZPE-510/images/Newsela-Research-and-Efficacy.pdf",
      resource_link_text: "Open PDF",
      todo_item: "",
    },
  ],
};

export default instructionalBestPractices;
